import { dateFriendly } from '../helpers/date';

/**
 * Transform branch group assign
 * @param {Object} input branch group assign
 * @returns {Object} branch group assign
 */
export const transformBranchGroupAssign = (input = {}) => {
	return {
		id: input.id || '',
		itecBranchId: input.itec_branch_id || '',
		nameTh: input.name_th || '',
		nameEn: input.name_en || '',
		assignedAt: input.assigned_at ? dateFriendly(input.assigned_at, 'DD MMM YYYY') : '-',
	};
};

/**
 * Transform branch groups assign
 * @param {Array} input branch groups assign
 * @returns {Array} branch groups assign
 */
export const transformBranchGroupAssigns = (input = []) => {
	return input.map((item) => transformBranchGroupAssign(item));
};